<div class="unauthorized">
  <img
    class="unauthorized__logo"
    src="/resources/images/finquery-logo-white.png"
    alt="FinQuery, formerly LeaseQuery"
    height="48"
  />

  <h1 class="unauthorized__heading">Not authorized.</h1>

  <p class="unauthorized__message">You are not authorized to view this page.</p>

  <button
    data-dd-action-name="unauthorized.go-back-button"
    type="button"
    class="unauthorized__back"
    (click)="goBack()"
  >
    <span aria-hidden="true">&larr;</span> Go Back
  </button>
</div>
